module.exports = "pegasus_template/assets/restaurant-alcohol-bar-drinks.png";